import BaseButton from 'products/nomad_insurance/components/Button';
import BaseModal from 'products/nomad_insurance/components/BaseModal';
import BaseTooltip from 'components/Tooltip';

import styled from 'styled-components';
import { sizes } from 'style';

// TODO: Refactor modal to use typescript so we don't have to use any here
export const Modal = styled(BaseModal)<any>`
  width: 755px;

  > button {
    display: none;
  }
`;

export const Tooltip = styled(BaseTooltip)<any>`
  display: inline;
  > span {
    font-weight: 400;
  }

  > div {
    padding: 14px;
    border-radius: 12px;
    background-color: #10181d;
    width: 213px;
    top: 120%;
    left: -45px;
  }
`;

export const Subheading = styled.p`
  margin: 0;
`;

export const ModalCards = styled.div`
  display: flex;
  gap: 16px;
`;

export const ModalCard = styled.div`
  background-color: ${({ theme }) => theme.colors['fountainBlue+4']};
  color: ${({ theme }) => theme.colors.black};
  font-size: 16px;
  letter-spacing: -0.1px;
  border-radius: 24px;
  flex-direction: column;
  text-align: left;
  gap: 16px;
  width: 100%;
  display: none;

  > h3 {
    margin: 0;
    text-align: center;
  }

  > ul {
    padding: 0;
    margin: 0;
    list-style: none;

    > li {
      display: flex;
      gap: 8px;

      > P {
        margin: 0;
      }

      > svg {
        margin-top: 3px;
        flex-shrink: 0;
        color: ${({ theme }) => theme.colors.red};
      }

      :not(:last-child) {
        margin-bottom: 16px;
      }
    }
  }

  > P {
    margin: 0;
  }

  @media ${sizes.tabletPortrait} {
    padding: 16px;
    display: flex;
    width: 50%;
  }
`;

export const SubscriptionModalCard = styled(ModalCard)`
  background-color: transparent;
  color: ${({ theme }) => theme.colors.black};
  display: flex;

  > h3 {
    display: none;
  }

  > ul > li > svg {
    color: ${({ theme }) => theme.colors.sushi};
  }

  @media ${sizes.tabletPortrait} {
    background-color: ${({ theme }) => theme.colors.black};
    color: ${({ theme }) => theme.colors.white};

    > h3 {
      display: block;
    }

    > ul > li > svg {
      color: ${({ theme }) => theme.colors.yellow};
    }
  }
`;

export const MobileTitle = styled.h3`
  margin: 0;
  text-align: center;
  font-size: 16px;

  @media ${sizes.tabletPortrait} {
    display: none;
  }
`;

export const Button = styled(BaseButton)`
  border-radius: 16px;
  padding: 12px;
  box-shadow: none;
  margin-top: 12px;
`;

export const PayUpfrontButton = styled(Button)`
  margin-top: 0;

  @media ${sizes.tabletPortrait} {
    display: none;
  }
`;

export const DesktopSubscribeButton = styled(Button)`
  display: none;
  margin-top: auto;
  @media ${sizes.tabletPortrait} {
    display: block;
  }
`;

export const MobileSubscribeButton = styled(Button)`
  @media ${sizes.tabletPortrait} {
    display: none;
  }
`;
